import React from 'react';
import './ActiveReceivingHeader.css';
import { PanelHeaderProps } from 'components/TradeTabPanel/TradePanelSection';

// The black block on /receiving: title plus the per-tab panel as its child
export default function ActiveReceivingHeader({ collapseControl, children }: PanelHeaderProps) {
  return (
    <div className="active-receiving-header-container ttp-block">
      {/* ttp-block-head floats over the map, which runs under it */}
      <div className="active-receiving-header ttp-block-head">
        <h2 className="active-receiving-title">Active Trades</h2>
        {collapseControl}
      </div>
      {children}
    </div>
  );
}
